import Vue from "vue";
import App from "./App.vue";
import ProjectService from "@/services/ProjectService.js";
import Vuetify from "vuetify";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import JwPagination from "jw-vue-pagination";
import NotFound from "@/views/NotFound.vue";
import NetworkError from "@/views/NetworkError.vue";
Vue.component("jw-pagination", JwPagination);

import VueSessionStorage from "vue-sessionstorage";
Vue.use(VueSessionStorage);
//Vue.use(ProjectService);

const opts = {};
export default new Vuetify(opts);
import "video.js/dist/video-js.css";
import * as uiv from "uiv";
import "./assets/pagination.css";
import "bootstrap/dist/css/bootstrap.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Router from "vue-router";

import Home from "@/views/home.vue";
import List from "@/views/list.vue";
import Summary from "@/views/summary.vue";
import Settings from "@/views/settings.vue";
import Correct from "@/views/correct.vue";
import Results from "@/views/results.vue";
import Results_Export from "@/views/results_export.vue";
import Exit from "@/views/exit.vue";
import SettingsFilter from "@/views/settings_filter.vue";
import SettingsFilterConfidence from "@/views/settings_filter_confidence.vue";
import SettingsFilterMoving from "@/views/settings_filter_moving.vue";

import SettingsZones from "@/views/settings_zones.vue";
import SettingsZonesTest from "@/views/settings_zones_test.vue";

import SettingsLooseEnds from "@/views/settings_loose_ends.vue";
import SettingsLooseEndsA from "@/views/settings_loose_ends_a.vue";
import SettingsLooseEndsM from "@/views/settings_loose_ends_m.vue";

import SettingsRouting from "@/views/settings_routing.vue";
import SettingsRoutingTest from "@/views/settings_routing_test.vue";

import SettingsClass from "@/views/settings_class.vue";
import SettingsClassTest from "@/views/settings_class_test.vue";
import SettingsClassManual from "@/views/settings_class_manual.vue";
import SettingsDirections from "@/views/settings_directions.vue";

import CorrectLooseEnds from "@/views/correct_loose_ends.vue";
import CorrectRouting from "@/views/correct_routing.vue";
import CorrectClass from "@/views/correct_class.vue";
import CorrectClassTest from "@/views/correct_class_test.vue";

import VueDragscroll from "vue-dragscroll";

//Vue.prototype.$range1;

Vue.use(VueDragscroll);
Vue.use(VuejsDialog);
const router = new Router({
  mode: "history", // zorgt er voor dat de # in url verdwijnt
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/list",
      name: "list",
      component: List
    },
    {
      path: "/summary",
      name: "summary",
      component: Summary
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings
    },
    {
      path: "/correct",
      name: "correct",
      component: Correct
    },
    {
      path: "/results",
      name: "results",
      component: Results
    },
    {
      path: "/results_export",
      name: "results_export",
      component: Results_Export
    },
    {
      path: "/exit",
      name: "exit",
      component: Exit
    },
    {
      path: "/settings/filter",
      name: "settings_filter",
      component: SettingsFilter
    },
    {
      path: "/settings/filter/confidence",
      name: "settings_filter_confidence",
      component: SettingsFilterConfidence
    },
    {
      path: "/settings/filter/moving",
      name: "settings_filter_moving",
      component: SettingsFilterMoving
    },
    {
      path: "/settings/zones",
      name: "settings_zones",
      component: SettingsZones
    },
    {
      path: "/settings/zones/test",
      name: "settings_zones_test",
      component: SettingsZonesTest
    },
    {
      path: "/settings/loose_ends",
      name: "settings_loose_ends",
      component: SettingsLooseEnds
    },
    {
      path: "/settings/loose_ends/auto",
      name: "settings_zones_loose_endsa",
      component: SettingsLooseEndsA
    },
    {
      path: "/settings/loose_ends/manual",
      name: "settings_zones_loose_endsm",
      component: SettingsLooseEndsM
    },
    {
      path: "/settings/routing",
      name: "settings_routing",
      component: SettingsRouting
    },
    {
      path: "/settings/routing/test/:id",
      name: "settings_routing_test",
      component: SettingsRoutingTest,
      props: true
    },
    {
      path: "/settings/class",
      name: "settings_class",
      component: SettingsClass
    },
    {
      path: "/settings/class/test/:id",
      name: "settings_class_test",
      component: SettingsClassTest,
      props: true
    },
    {
      path: "/settings/classmanual",
      name: "settings_class_manual",
      component: SettingsClassManual
    },
    {
      path: "/settings/directions",
      name: "settings_directions",
      component: SettingsDirections
    },
    {
      path: "/correct/loose_ends",
      name: "correct_loose_ends",
      component: CorrectLooseEnds
    },
    {
      path: "/correct/routing",
      name: "correct_routing",
      component: CorrectRouting
    },
    {
      path: "/correct/class",
      name: "correct_class",
      component: CorrectClass
    },
    {
      path: "/correct/class/test/:class/:class_status",
      name: "correct_class_test",
      component: CorrectClassTest,
      props: true
    },
    {
      path: "/:catchAll(.*)",
      name: "NotFound",
      component: NotFound
    },
    {
      path: "/404/:resource",
      name: "404Resource",
      component: NotFound,
      props: true
    },
    {
      path: "/network-error",
      name: "NetworkError",
      component: NetworkError
    }
  ]
});

library.add(faUserSecret);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(uiv);
Vue.use(Vuetify);
Vue.use(Router);
Vue.use(ProjectService);
Vue.config.productionTip = true;

import {
  faHandHolding,
  faSmile,
  faFrown,
  faQuestion,
  faTrailer,
  faCompass,
  faTruckMoving,
  faTruckMonster,
  faRecycle,
  faFilter,
  faRoute,
  faObjectUngroup,
  faSignOutAlt,
  faCompress,
  faHome,
  faStamp,
  faPastafarianism,
  faList,
  faUserSecret,
  faQuestionCircle,
  faDharmachakra,
  faSpinner,
  faCogs,
  faEye,
  faCheck,
  faChartBar,
  faFileExport,
  faAlignLeft,
  faCodeBranch,
  faHandPointer,
  faBalanceScale,
  faVectorSquare,
  faDiagnoses,
  faWalking,
  faBicycle,
  faBus,
  faTruck,
  faCaravan,
  faCar,
  faShuttleVan,
  faMotorcycle,
  faTrash,
  faSubway,
  faTaxi,
  faTractor,
  faTruckPickup,
  faTrain
} from "@fortawesome/free-solid-svg-icons";

import vuetify from "./plugins/vuetify";
library.add(
  faHandHolding,
  faSmile,
  faFrown,
  faQuestion,
  faTrailer,
  faTruckMonster,
  faTruckMoving,
  faTruckPickup,
  faQuestionCircle,
  faTrain,
  faTractor,
  faTaxi,
  faSubway,
  faTrash,
  faMotorcycle,
  faDiagnoses,
  faCompass,
  faShuttleVan,
  faWalking,
  faSignOutAlt,
  faVectorSquare,
  faObjectUngroup,
  faRecycle,
  faFilter,
  faRoute,
  faBicycle,
  faBus,
  faCodeBranch,
  faCaravan,
  faHome,
  faCar,
  faCompress,
  faTruck,
  faStamp,
  faPastafarianism,
  faList,
  faUserSecret,
  faDharmachakra,
  faSpinner,
  faCogs,
  faEye,
  faCheck,
  faChartBar,
  faFileExport,
  faAlignLeft,
  faHandPointer,
  faBalanceScale
);

new Vue({
  watch: {
    $route: function(current) {
      const route = this.$router.options.routes.find(
        route => route.path === current.path
      );

      if (route && Array.isArray(route.children)) {
        this.children = route.children;
      } else if (route) {
        this.children = [];
      }
    }
  },
  data: {
    imgfiguren: "../assets/images/figuren.jpg"
  },
  router,
  ProjectService,
  uiv,
  library,
  FontAwesomeIcon,
  faUserSecret,
  //store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
